import React from "react";

const TermsAndConditionsFr = () => {
  return (
    <div className="container mx-auto px-4 py-8 text-onWhite">
      <h1 className="text-center text-3xl font-bold mb-6">
        CONDITIONS GÉNÉRALES D’UTILISATION
      </h1>
      <p className="text-center text-lg mb-6">
        ANANAS SOLUTIONS – Un produit de Ananas Acti-Solutions inc.
      </p>
      <p className="text-center mb-4">
        <strong>Date de dernière mise à jour : 2 octobre 2025</strong>
      </p>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">
          1. Acceptation des Conditions
        </h2>
        <p>
          Les présentes conditions générales (« Conditions ») régissent votre
          accès et votre utilisation du site web, des services et plateformes
          exploités sous la marque <strong>ANANAS SOLUTIONS</strong>, un produit
          de <strong>Ananas Acti-Solutions inc.</strong> (« nous », « notre », «
          nos »). En accédant à nos services, vous acceptez d’être lié par ces
          Conditions. Si vous n’acceptez pas ces Conditions, vous devez cesser
          toute utilisation de nos services.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">2. Modifications</h2>
        <p>
          Nous nous réservons le droit de modifier ces Conditions à tout moment,
          sans préavis. La version en vigueur est celle publiée sur notre site.
          Votre utilisation continue constitue une acceptation des Conditions
          révisées.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">
          3. Propriété intellectuelle
        </h2>
        <p>
          Tous les contenus, marques, logos, textes, images, vidéos et
          fonctionnalités du site sont protégés par le droit d’auteur, les
          marques de commerce et autres lois applicables et demeurent la
          propriété exclusive de <strong>Ananas Acti-Solutions inc.</strong> ou
          de ses concédants.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">4. Comptes utilisateurs</h2>
        <p>
          Pour utiliser certaines fonctionnalités, vous devez créer un compte.
          Vous êtes responsable du maintien de la confidentialité de vos
          identifiants, de l’exactitude des informations fournies et de toute
          activité effectuée à partir de votre compte. Tout usage abusif ou
          frauduleux entraînera la suspension ou la résiliation de votre compte.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">
          5. Paiements et abonnements
        </h2>
        <p>
          Tous les achats et abonnements effectués via nos services sont soumis
          aux conditions affichées au moment de la transaction. Les paiements
          sont traités par nos prestataires autorisés (ex. Stripe). Vous
          acceptez que les taxes, frais de service et frais applicables soient
          ajoutés au prix affiché. Sauf disposition contraire prévue par la loi,
          aucun remboursement n’est possible.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">
          6. Produits et services tiers
        </h2>
        <p>
          Certains produits ou services peuvent être fournis par des tiers. Nous
          ne sommes pas responsables de leur qualité, conformité, légalité ou
          sécurité. Tout litige devra être adressé directement au fournisseur ou
          vendeur concerné.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">
          7. Utilisation acceptable
        </h2>
        <p>
          Vous vous engagez à ne pas utiliser nos services à des fins illicites,
          diffamatoires, frauduleuses ou portant atteinte aux droits de tiers.
          Toute tentative de piratage, d’ingénierie inverse ou d’exploitation de
          failles de sécurité est strictement interdite.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">
          8. Protection des données
        </h2>
        <p>
          En utilisant nos services, vous acceptez que certaines données
          personnelles puissent être collectées et utilisées conformément à
          notre Politique de confidentialité. Vos données sont traitées au
          Canada, et potentiellement dans tout autre pays où nous opérons.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">
          9. Limitation de responsabilité
        </h2>
        <p>
          Dans toute la mesure permise par la loi,{" "}
          <strong>Ananas Acti-Solutions inc.</strong> décline toute
          responsabilité pour les pertes directes, indirectes, consécutives ou
          punitives liées à l’utilisation de nos services. Nos services sont
          fournis « tels quels » et sans garantie d’exactitude, d’exhaustivité
          ou de disponibilité.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">10. Force majeure</h2>
        <p>
          Nous ne serons pas responsables de tout retard ou défaut d’exécution
          causé par des événements hors de notre contrôle raisonnable, tels que
          catastrophes naturelles, pannes majeures, cyberattaques, conflits de
          travail ou décisions gouvernementales.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">
          11. Droit applicable et juridiction
        </h2>
        <p>
          Les présentes Conditions sont régies par les lois du Québec et du
          Canada. Tout litige relatif à leur interprétation ou application
          relève de la compétence exclusive des tribunaux du district judiciaire
          de Montréal, Québec.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">12. Contact</h2>
        <p>
          Pour toute question, vous pouvez nous écrire à :{" "}
          <a
            href="mailto:privacy@ananassolutions.com"
            className="text-blue-500 underline"
          >
            privacy@ananassolutions.com
          </a>
        </p>
      </section>
    </div>
  );
};

export default TermsAndConditionsFr;
